import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isPopupOpen: false,
  permissionRequest: null
}

const slice = createSlice({
  name: 'organizationOutlook',
  initialState,
  reducers: {
    openPopup(state, { payload }) {
      state.isPopupOpen = true
      state.permissionRequest = payload
    },
    closePopup(state) {
      state.isPopupOpen = false
      state.permissionRequest = null
    }
  }
})

export const { reducer, actions: { openPopup, closePopup } } = slice
